<template>
  <el-card shadow="always" v-if="state == 'CHANGED'">
    <div slot="header" class="clearfix">
      <span>Destinatário</span>
    </div>
    <div>
      <el-form
        ref="form"
        :model="deliveryForm"
        label-width="120px"
        :label-position="labelPosition"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item class="no-margin-bottom" :label="$t('destinatario')" prop="delivery">
              <DeliveryList
                ref="deliveryList"
                v-model="deliveryForm.delivery"
                :customer="customer"
                v-on:clear="clear"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="no-margin-bottom" :label="$t('departamento')" prop="department">
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <DepartmentList
                  v-model="deliveryForm.department"
                  :customer="customer"
                />
            </el-col>
          </el-row>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
            <el-form-item
              :label="$t('nome')"
              prop="name"
              maxlength="50"
              class="no-margin-bottom"
              :required="true"
            >
              <el-input v-model="deliveryForm.name" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
            <el-form-item
              class="no-margin-bottom"
              :label="$t('cep')"
              prop="cep"
              :required="true"
            >
              <el-input
                maxlength="9"
                v-model="deliveryForm.cep"
                v-mask="'#####-###'"
                v-loading="loading"
                @blur="zipcode()"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item
              :label="$t('endereco')"
              prop="address"
              class="no-margin-bottom"
              :required="true"
            >
              <el-input v-model="deliveryForm.address" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="10">
            <el-form-item
              :label="$t('bairro')"
              prop="neighborhood"
              class="no-margin-bottom"
              :required="true"
            >
              <el-input v-model="deliveryForm.neighborhood" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="8">
            <el-form-item
              class="no-margin-bottom"
              :label="$t('cidade')"
              prop="city"
              :required="true"
            >
              <el-input v-model="deliveryForm.city" maxlength="40"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
            <el-form-item
              class="no-margin-bottom"
              :label="$t('estado')"
              prop="state"
              :required="true"
            >
              <el-input maxlength="2" v-model="deliveryForm.state"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="6">
            <el-form-item
              class="no-margin-bottom"
              label="Número"
              maxlength="6"
              :required="true"
            >
              <el-input maxlength="6" v-model="deliveryForm.number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="18">
            <el-form-item class="no-margin-bottom" label="Complemento">
              <el-input maxlength="40" v-model="deliveryForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="bottom clearfix">
          <el-button type="success" title="Salva o destinatário no sistema" @click="save()">Salvar</el-button>
          <el-button class="right" type="primary" @click="confirm()">Confirmar</el-button>
        </div>
      </el-form>
    </div>
  </el-card>
  <el-card shadow="always" style="min-height: 143px" v-else>
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <label style="font-weight: bold">Destinatário:</label>&nbsp;
        <label>{{ deliveryForm.name }} </label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="6" :xl="6">
        <label style="font-weight: bold">CEP:</label>&nbsp;
        <label>{{ deliveryForm.cep }}</label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <label style="font-weight: bold">Endereço:</label>&nbsp;
        <label>{{ deliveryForm.address }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Bairro:</label>&nbsp;
        <label>{{ deliveryForm.neighborhood }}</label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <label style="font-weight: bold">Cidade:</label>&nbsp;
        <label>{{ deliveryForm.city }} - {{ deliveryForm.state }}</label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="12" :xl="12">
        <label style="font-weight: bold">Complemento:</label>&nbsp;
        <label>{{ deliveryForm.extent }}</label>
      </el-col>
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-button type="info" @click="changed" size="mini">Alterar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { DeliveryService } from "@/services/delivery/delivery.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";
import { UserService } from "@/services/users/user.services";
import FederalId from "@/xpost/components/FederalId";
import DeliveryList from "@/xpost/views/register/delivery/DeliveryList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList";

export default {
  name: "PrePostSender",
  components: {
    FederalId,
    DeliveryList,
    DepartmentList,
  },
  props: ["customer", "state", "labelPosition", "userType"],
  watch: {
    "deliveryForm.delivery": function (newVal, oldVal) {
      const vm = this;
      vm.fetchDelivery();
    },
  },
  methods: {
    validate() {
      const vm = this;
      return (
        vm.deliveryForm.cep &&
        vm.deliveryForm.address &&
        vm.deliveryForm.neighborhood &&
        vm.deliveryForm.city &&
        vm.deliveryForm.state &&
        vm.deliveryForm.number &&
        vm.deliveryForm.name
      );
    },
    // Rótulos dos obrigatórios em branco (mesma lista do validate), para o aviso da tela nomear o campo
    missingFields() {
      const form = this.deliveryForm;
      const required = [
        ["name", this.$t("nome")],
        ["cep", this.$t("cep")],
        ["address", this.$t("endereco")],
        ["neighborhood", this.$t("bairro")],
        ["city", this.$t("cidade")],
        ["state", this.$t("estado")],
        ["number", this.$t("numero")],
      ];
      return required.filter(([key]) => !form[key]).map(([, label]) => `${label} do destinatário`);
    },
    zipcode: function () {
      const vm = this;
      if (!vm.deliveryForm.cep) {
        return false;
      }
      const loading = vm.$loading(vm.$options.loading);
      PostOfficeService.zipcode(vm.deliveryForm.cep)
        .then((response) => {
          vm.deliveryForm.address = response.end;
          vm.deliveryForm.city = response.cidade;
          vm.deliveryForm.state = response.uf;
          vm.deliveryForm.neighborhood = response.bairro;
          if (response.offline) {
            this.$message({
              type: "warning",
              message: "Serviços de consulta de CEP indisponível, não foi possível consultar os dados do CEP!",
              duration: 5000,
            });
          }
        })
        .catch(() => {
          vm.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      DeliveryService.add({
        customer: vm.customer,
        name: vm.deliveryForm.name,
        cep: vm.deliveryForm.cep,
        extent: vm.deliveryForm.extent,
        address: vm.deliveryForm.address,
        mail: "",
        city: vm.deliveryForm.city,
        state: vm.deliveryForm.state,
        neighborhood: vm.deliveryForm.neighborhood,
        number: vm.deliveryForm.number,
        mobile: "",
        phone: "",
      })
        .then((response) => {
          if (vm.$refs.deliveryList) vm.$refs.deliveryList.fetchDepartment();
          this.$message({
            type: "success",
            message: i18n.tc("destinatario-adicionado-sucesso"),
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    confirm() {
      const vm = this;
      vm.$emit("confirm");
    },
    changed() {
      const vm = this;
      vm.$emit("changed");
    },
    fetchDelivery() {
      const vm = this;
      if (!vm.deliveryForm.delivery) return false;
      vm.loading = true;
      DeliveryService.get(vm.deliveryForm.delivery)
        .then((response) => {
          vm.deliveryForm.cep = response.zipcode.zipcode;
          vm.deliveryForm.address = response.address || response.zipcode.address;
          vm.deliveryForm.name = response.name;
          vm.deliveryForm.neighborhood = response.neighborhood || response.zipcode.neighborhood;
          vm.deliveryForm.city = response.zipcode.city;
          vm.deliveryForm.state = response.zipcode.state;
          vm.deliveryForm.number = response.number;
          vm.deliveryForm.extent = response.extent;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
    clear() {
      const vm = this;
      vm.deliveryForm.delivery = "";
      vm.deliveryForm.department = "";
      vm.deliveryForm.cep = "";
      vm.deliveryForm.contact = "";
      vm.deliveryForm.address = "";
      vm.deliveryForm.neighborhood = "";
      vm.deliveryForm.city = "";
      vm.deliveryForm.state = "";
      vm.deliveryForm.number = "";
      vm.deliveryForm.extent = "";
      vm.deliveryForm.name = "";
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {})
      .catch((error) => {
        vm.$message.error({
          type: "error",
          message: error,
          duration: 5000,
        });
      });
  },
  data() {
    return {
      loading: false,
      deliveryForm: {
        delivery: "",
        department: "",
        cep: "",
        contact: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        extent: "",
        name: "",
      },
    };
  },
};
</script>
